import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=b8bb2dbc&"
import script from "./PurchaseList.vue?vue&type=script&lang=js&"
export * from "./PurchaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports